module.exports = __webpack_public_path__ + "static/media/2.5914b7c0.png";